"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteAccountTab = DeleteAccountTab;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Translations = require("react-platform-components/dist/Translations");
var _helpers = require("react-platform-components/dist/helpers");
var _config = require("../../config");
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _ProfileActions = require("../ProfileActions");
var _index = require("react-platform-components/dist/helpers/index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = function useStyles(makeStyles) {
  return {
    cardShadow: {
      boxShadow: '4px 3px 20px #c7c7c7'
    },
    title: {
      paddingBottom: 24
    },
    padding: {
      padding: "0 15px"
    },
    whatever: {
      margin: "0 15px"
    }
  };
};
function DeleteAccountTab() {
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleClickOpen = function handleClickOpen() {
    setOpen(true);
  };
  var dispatch = (0, _reactRedux.useDispatch)();
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var handleDispatch = function handleDispatch() {
    dispatch({
      type: _ProfileActions.DELETE_ACCOUNT,
      onSuccess: function onSuccess() {
        return dispatch({
          type: "HANDLE_SUCCESS_MESSAGE",
          message: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
            id: "Successfully requested deleting",
            defaultMessage: "Successfully requested deleting"
          })
        });
      }
    });
    setOpen(false);
  };
  var user = (0, _reactRedux.useSelector)(function (state) {
    return state.auth.user;
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: (0, _classnames.default)('m-4 md:m-8', classes.cardShadow, classes.padding)
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    md: 8,
    className: "px-4 md:px-20 pt-8 pb-12"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    className: "py-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline",
    className: "text-gray-600"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Date de cr\xE9ation du compte",
    defaultMessage: "Date de cr\xE9ation du compte"
  })), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body1"
  }, " ", (0, _index.formatDate)(user.registered_at), " ")), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    container: true,
    className: classes.title,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "overline",
    className: (0, _classnames.default)('text-gray-600', classes.whatever)
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Supprimer le compte",
    defaultMessage: "Supprimer le compte"
  }))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: handleClickOpen
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Delete Account",
    defaultMessage: "Delete Account"
  }))))))), /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    id: "alert-dialog-title"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "delete_pop_up_title"
  })), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, /*#__PURE__*/_react.default.createElement(_DialogContentText.default, {
    id: "alert-dialog-description"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Do you really want to delete your account ?",
    defaultMessage: "Do you really want to delete your account ?"
  }))), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleClose,
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Disagree",
    defaultMessage: "Disagree"
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    onClick: handleDispatch,
    color: "primary",
    autoFocus: true
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Agree",
    defaultMessage: "Agree"
  })))));
}